"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainingWeek = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const structural_organisms_1 = require("../structural-organisms");
const styled_components_1 = __importDefault(require("styled-components"));
const TrainingPreview_1 = require("./TrainingPreview");
const TrainingWeek = (props) => {
    return ((0, jsx_runtime_1.jsx)(List, { children: [
            props.header,
            (0, jsx_runtime_1.jsx)(TrainingPreview_1.TrainingPreview, { weekItems: props.trainingItemsData }, "content")
        ] }, void 0));
};
exports.TrainingWeek = TrainingWeek;
const List = (0, styled_components_1.default)(structural_organisms_1.ListWithMargin) `
  margin-bottom: ${({ theme }) => theme.spacings.xl};

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    margin-bottom: 0;
  }
`;
//# sourceMappingURL=TrainingWeek.js.map